<template>
  <div d-flex column class="creditor-wrapper">
    <div class="creditors-container d-flex">
      <small class="creditors-number text-no-wrap grey--text mb-1">
        {{ creditors.length }} Credor{{ creditors.length === 1 ? "" : "es" }}
      </small>
      <div class="creditors-row">
        <CreditorChip
          v-for="(creditorId, index) in creditors.slice(
            0,
            maxCreditorsToDisplay,
          )"
          :key="creditorId"
          :creditors="allCreditors"
          :creditor-id="creditorId"
          :others="
            index === maxCreditorsToDisplay - 1
              ? creditors.slice(maxCreditorsToDisplay)
              : []
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
import CreditorChip from "./CreditorChip.vue";

export default {
  name: "CreditorsDisplay",
  components: {
    CreditorChip,
  },
  props: {
    creditors: {
      type: Array,
      default: () => [],
    },
    allCreditors: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      maxCreditorsToDisplay: 5,
    };
  },
};
</script>

<style lang="scss" scoped>
.creditor-wrapper {
  width: 100%;
  height: 100%;
}
.creditors-container {
  height: fit-content;
  flex-direction: column;
}

.creditors-row {
  min-width: max-content;
  max-width: 110px;
}

.creditors-number {
  color: rgba(0, 0, 0, 0.12);
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
